import React from "react";
import { Link } from "react-router-dom";
import "../styles/homePage.css";
import ContactFloat from "./contactFloat";

const HomePage = ({ data }) => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <>
      <section className="titlePageWrap">
        <div className="titlePageText">
          <img src="/HiALogoWhite.png" alt="title" />
          <h1>The Transformative Learning People</h1>
          <Link to="/aboutUs" onClick={scrollToTop}>
            <button>About Us</button>
          </Link>
          <Link to="/howWeCanHelp" onClick={scrollToTop}>
            <button>How We Can Help</button>
          </Link>
        </div>
      </section>

      <section className="howWeCanHelp">
        <h2>How we can help</h2>
        <div className="howWeCanHelpWrap">
          <div className="howWeCanHelpItem1">
            <div className="imgContainer1">
              {/* <img src={eye} alt="Eye" /> */}
            </div>
            <div className="contentContainer1">
              <h4>EXPERTISE AND EXPERIENCE</h4>
              <p>
                With a team of seasoned professionals, we bring extensive
                knowledge and industry experience to every project. Our
                facilitators and consultants are experts in their fields,
                dedicated to delivering high-quality, impactful learning
                experiences
              </p>
            </div>
          </div>
          <div className="howWeCanHelpItem2">
            <div className="imgContainer2">
              {/* <img src={pencil} alt="Eye" /> */}
            </div>
            <div className="contentContainer2">
              <h4>TAILORED SOLUTIONS</h4>
              <p>
                We understand that every organisation is unique. Our solutions
                are customised to address your specific challenges and goals,
                ensuring maximum relevance and effectiveness
              </p>
            </div>
          </div>
          <div className="howWeCanHelpItem3">
            <div className="imgContainer3">
              {/* <img src={lightbulb} alt="Eye" /> */}
            </div>
            <div className="contentContainer3">
              <h4>PROVEN RESULTS</h4>
              <p>
                Our approach is data-driven and results-oriented. We measure the
                impact of our programs and continuously refine our methods to
                ensure you receive the highest return on your investment
              </p>
            </div>
          </div>
          <div className="howWeCanHelpItem4">
            <div className="imgContainer4">
              {/* <img src={cog} alt="Eye" /> */}
            </div>
            <div className="contentContainer4">
              <h4>CLIENT-CENTRIC APPROACH</h4>
              <p>
                Your success is our priority. We work collaboratively with you,
                listening to your needs and adapting our services to provide the
                support and resources you need to thrive
              </p>
            </div>
          </div>
        </div>
        {/* 
        <div className="howWeCanHelpButton">
          <h1>Ready to transform your interActions?</h1>
          <p>
            Partner with Healthcare interAction and unlock your and your team’s
            full potential
          </p>
          <Link to="/howWeCanHelp" onClick={scrollToTop}>
            <button>Transform your teams NOW</button>
          </Link>
        </div> */}
      </section>

      <section className="clients">
        <h2>Our Clients</h2>
        <div className="clientsWrap">
          <div className="clientsList">
            {data.map(({ id, img }) => (
              <div key={id} className="clientImg">
                <img src={img} alt="client" />
              </div>
            ))}
          </div>
          <div className="clientsList">
            {data.map(({ id, img }) => (
              <div key={id} className="clientImg">
                <img src={img} alt="client" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <ContactFloat />

      <section className="quote">
        <h1 className="quoteStart" id="quoteStartHome">
          ‘‘
        </h1>
        <p>
          I wanted to thank you for all of the support, motivation and coaching
          that you have provided me in the last 6 months. It’s been great
          working with you. As they say, ‘the proof is in the pudding’, our
          patient uptake has increased 600% annually.
        </p>
        <h1 className="quoteEnd" id="quoteEndHome">
          ’’
        </h1>
      </section>
    </>
  );
};

export default HomePage;
